import api from 'services/api'
import { getStoreId } from 'services/api/parser/serviceEligibility'

import {
  GET_SERVICE_ELIGIBILITY_SUCCESS,
  GET_SERVICE_ELIGIBILITY_FAILURE,
} from '../../constants'

const getStoreIdSuccess = response => ({
  type: GET_SERVICE_ELIGIBILITY_SUCCESS,
  response,
})

const getStoreIdFailure = response => ({
  type: GET_SERVICE_ELIGIBILITY_FAILURE,
  response,
})

const serviceEligibility = postalCode => dispatch =>
  api.request('serviceEligibility', { appendPath: postalCode }).then(({ data }) => {
    const storeId = getStoreId(data || {})
    dispatch(getStoreIdSuccess({ storeId }))
  }).catch((error) => {
    dispatch(getStoreIdFailure(error))
  })

export default serviceEligibility



// WEBPACK FOOTER //
// ./services/app-state/profile/actions/serviceEligibility/index.js